export const stories = [
  {
    id: "s1",
    title: "初为人母的清晨",
    subtitle: "第一季 · 第1集",
    season: "第一季",
    episode: 1,
    tags: ["开篇", "温情", "家庭"],
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20morning%20light%20through%20a%20kitchen%20window%2C%20a%20young%20mother%20cradling%20a%20newborn%20by%20a%20wooden%20table%2C%20soft%20terracotta%20and%20cream%20tones%2C%20cinematic%20family%20drama%20still%2C%20shallow%20depth%20of%20field%2C%20nostalgic%20film%20grain&width=800&height=450&seq=story-01&orientation=landscape",
    summary:
      "故事从苏念产后回到家的第一个清晨开始，手忙脚乱的新手母亲在母亲何淑芬的帮助下，第一次体会到“被需要”的重量。",
    content: [
      "天刚蒙蒙亮，苏念就被婴儿的哭声唤醒。她拖着疲惫的身体走到摇篮边，笨拙地抱起女儿小满，客厅里只亮着一盏暖黄的落地灯。",
      "何淑芬端着一碗热粥从厨房走出来，没有责备，只是默默接过孩子，让女儿先吃口热的。两代人关于育儿的分歧，在这一顿沉默的早餐里第一次露出端倪。",
      "江辰出门上班前在门口停顿了几秒，想说些什么，最终只留下一句“晚上我早点回”。门关上的声音，成了苏念这一天里最清晰的声音。",
    ],
    publishedAt: "2024-03-08",
    castIds: ["c1", "c3", "c2", "c4"],
    clipIds: ["k13", "k1"],
  },
  {
    id: "s2",
    title: "重返职场的抉择",
    subtitle: "第一季 · 第2集",
    season: "第一季",
    episode: 2,
    tags: ["职场", "抉择", "成长"],
    cover:
      "https://readdy.ai/api/search-image?query=Young%20woman%20standing%20in%20a%20bright%20modern%20office%20corridor%20holding%20a%20laptop%2C%20thoughtful%20expression%2C%20warm%20neutral%20interior%20with%20wood%20and%20glass%2C%20cinematic%20drama%20still%2C%20soft%20daylight%2C%20muted%20terracotta%20accents&width=800&height=450&seq=story-02&orientation=landscape",
    summary:
      "产假即将结束，苏念在回公司与照顾孩子之间反复权衡。一次与同事顾南枝的见面，让她重新审视自己想要成为什么样的人。",
    content: [
      "苏念翻出压在抽屉底部的工牌，指尖在照片上停了一会儿。那是三年前的她，眼神里还没有现在这样的疲惫。",
      "顾南枝约她在公司楼下的咖啡馆见面，带来了团队最近的变动消息。她说，位置还留着，但没有人会一直等。",
      "回家路上，苏念在小区门口看到别的母亲牵着孩子放学，忽然明白——所谓抉择，从来不是二选一，而是愿不愿意为自己负责。",
    ],
    publishedAt: "2024-03-15",
    castIds: ["c1", "c8", "c3"],
    clipIds: ["k1"],
  },
  {
    id: "s3",
    title: "婆媳之间的分寸",
    subtitle: "第一季 · 第3集",
    season: "第一季",
    episode: 3,
    tags: ["家庭", "冲突", "温情"],
    cover:
      "https://readdy.ai/api/search-image?query=Two%20generations%20of%20women%20sitting%20across%20a%20dining%20table%20in%20a%20warm%20home%2C%20tension%20and%20tenderness%2C%20porcelain%20bowls%20and%20tea%2C%20soft%20window%20light%2C%20cinematic%20family%20drama%20still%2C%20cream%20and%20clay%20palette&width=800&height=450&seq=story-03&orientation=landscape",
    summary:
      "一次关于“要不要给孩子加辅食”的争执，让苏念和婆婆秦姨之间的矛盾彻底摆上台面，也让江辰第一次被迫站出来做选择。",
    content: [
      "厨房里，秦姨坚持用老办法喂孩子，苏念拿着医生给的辅食表，谁都不肯退让。孩子被夹在中间，哭得停不下来。",
      "江辰下班回家，看到的是三张沉默的脸。他第一次意识到，自己一直以来的“和稀泥”，才是问题的一部分。",
      "夜深了，秦姨主动敲开苏念的房门，说了句“妈也是第一次当奶奶”。这句话，让两个人的距离近了一点点。",
    ],
    publishedAt: "2024-03-22",
    castIds: ["c1", "c12", "c2", "c4"],
    clipIds: ["k5"],
  },
  {
    id: "s4",
    title: "孩子的第一场发烧",
    subtitle: "第一季 · 第4集",
    season: "第一季",
    episode: 4,
    tags: ["危机", "亲情", "成长"],
    cover:
      "https://readdy.ai/api/search-image?query=Anxious%20young%20mother%20holding%20a%20feverish%20baby%20in%20a%20dim%20bedroom%20at%20night%2C%20warm%20lamplight%20and%20deep%20shadows%2C%20cinematic%20drama%20still%2C%20emotive%20atmosphere%2C%20muted%20amber%20and%20brown%20tones&width=800&height=450&seq=story-04&orientation=landscape",
    summary:
      "小满深夜高烧，苏念独自抱着孩子冲向医院。在急诊走廊的漫长等待里，她第一次真正读懂了自己母亲当年的沉默。",
    content: [
      "温度计上的数字一路攀升，苏念的手却在发抖。江辰出差在外，电话那头只有忙音。",
      "她一个人抱着孩子，在深夜的马路边拦车。风很凉，孩子的小脸贴在她脖子上，烫得让人心疼。",
      "急诊室的灯白得刺眼。何淑芬赶来时，苏念终于没忍住，在母亲肩头哭出了声。",
    ],
    publishedAt: "2024-03-29",
    castIds: ["c1", "c3", "c6"],
    clipIds: ["k7"],
  },
  {
    id: "s5",
    title: "旧友重逢的午后",
    subtitle: "第一季 · 第5集",
    season: "第一季",
    episode: 5,
    tags: ["情感", "回忆", "转折"],
    cover:
      "https://readdy.ai/api/search-image?query=Two%20old%20friends%20meeting%20in%20a%20sunlit%20cafe%20by%20a%20large%20window%2C%20coffee%20cups%20and%20warm%20afternoon%20light%2C%20gentle%20surprise%20expressions%2C%20cinematic%20drama%20still%2C%20creamy%20terracotta%20and%20beige%20palette&width=800&height=450&seq=story-05&orientation=landscape",
    summary:
      "多年未见的沈予安意外出现在苏念家附近，两人在咖啡馆聊起从前。一段被尘封的往事，让苏念重新审视自己现在的生活。",
    content: [
      "沈予安推门进来的时候，苏念差点没认出来。他的头发短了，笑起来却还是老样子。",
      "两个人从工作聊到生活，又聊到当年那场没有结果的告别。苏念说自己已经很久没有为自己做过决定了。",
      "离开时，沈予安说：“你还是那个会把所有事都扛在自己肩上的人。”这句话在苏念心里留了很久。",
    ],
    publishedAt: "2024-04-05",
    castIds: ["c1", "c5"],
    clipIds: ["k11"],
  },
  {
    id: "s6",
    title: "一场没有预约的告白",
    subtitle: "第一季 · 第6集",
    season: "第一季",
    episode: 6,
    tags: ["情感", "高潮", "抉择"],
    cover:
      "https://readdy.ai/api/search-image?query=A%20man%20and%20a%20woman%20talking%20on%20a%20quiet%20apartment%20balcony%20at%20dusk%2C%20city%20lights%20blurring%20behind%20them%2C%20tense%20and%20tender%20moment%2C%20cinematic%20drama%20still%2C%20warm%20dusk%20orange%20and%20brown%20tones&width=800&height=450&seq=story-06&orientation=landscape",
    summary:
      "江辰察觉到妻子的变化，在两个人都沉默的夜晚正式谈了一次。这场迟到的坦白，成为第一季最重要的转折。",
    content: [
      "客厅的电视开着，谁都没有在看。江辰先开口，说他知道苏念最近不开心。",
      "苏念没有回避。她说自己不是想离开这个家，只是快要忘了自己是谁。",
      "那晚之后，两个人重新分工，也重新学会了好好说话。窗外的天，慢慢亮了起来。",
    ],
    publishedAt: "2024-04-12",
    castIds: ["c1", "c2"],
    clipIds: ["k2"],
  },
  {
    id: "s7",
    title: "被误解的善意",
    subtitle: "第二季 · 第1集",
    season: "第二季",
    episode: 1,
    tags: ["新篇", "误会", "成长"],
    cover:
      "https://readdy.ai/api/search-image?query=Young%20mother%20sitting%20alone%20by%20a%20rain-streaked%20window%20looking%20thoughtful%2C%20soft%20grey%20daylight%20with%20warm%20interior%20accents%2C%20cinematic%20drama%20still%2C%20melancholic%20yet%20tender%20mood&width=800&height=450&seq=story-07&orientation=landscape",
    summary:
      "第二季开篇，苏念重返职场后，一次善意的帮助被同事误解成多管闲事。她在委屈与成长之间，学会了为自己发声。",
    content: [
      "苏念帮同事程屿顶了一个紧急的项目，却在汇报会上被说成“抢功”。",
      "顾南枝替她不平，苏念却只是安静地整理好资料，在下次会议上用数据把话讲清楚。",
      "下班后她给家里打了个电话，小满在电话里喊了一声“妈妈”。所有的委屈，好像都值了。",
    ],
    publishedAt: "2024-09-06",
    castIds: ["c1", "c11", "c8"],
    clipIds: ["k1"],
  },
  {
    id: "s8",
    title: "深夜的急诊室",
    subtitle: "第二季 · 第2集",
    season: "第二季",
    episode: 2,
    tags: ["危机", "守护", "转折"],
    cover:
      "https://readdy.ai/api/search-image?query=Hospital%20emergency%20corridor%20at%20night%20with%20soft%20warm%20lighting%2C%20a%20doctor%20in%20white%20coat%20speaking%20gently%2C%20cinematic%20drama%20still%2C%20calm%20and%20reassuring%20atmosphere%2C%20muted%20teal-free%20warm%20neutral%20tones&width=800&height=450&seq=story-08&orientation=landscape",
    summary:
      "秦姨在家中意外摔倒，一家人再次聚在急诊室外。这场意外让原本紧张的关系，出现了缓和的契机。",
    content: [
      "接到电话的时候，苏念正在加班。她冲进急诊室，看到的是江辰握着母亲手的背影。",
      "陆行舟医生耐心地解释病情，说幸好送来得及时。苏念靠在墙边，第一次觉得这个家谁都不能少。",
      "病房里，秦姨醒来第一句话是问孩子。苏念握住她的手，说了一句久违的“妈，您先好好休息”。",
    ],
    publishedAt: "2024-09-13",
    castIds: ["c1", "c12", "c6", "c2"],
    clipIds: ["k7"],
  },
  {
    id: "s9",
    title: "母亲的老照片",
    subtitle: "第二季 · 第3集",
    season: "第二季",
    episode: 3,
    tags: ["回忆", "亲情", "温情"],
    cover:
      "https://readdy.ai/api/search-image?query=Old%20faded%20family%20photographs%20spread%20on%20a%20wooden%20table%20with%20warm%20lamp%20light%2C%20hands%20gently%20holding%20a%20photo%2C%20nostalgic%20cinematic%20drama%20still%2C%20sepia%20and%20terracotta%20tones&width=800&height=450&seq=story-09&orientation=landscape",
    summary:
      "整理旧物时，苏念发现了何淑芬年轻时的照片。照片背后的故事，让她重新理解了母亲一生中那些没说出口的牺牲。",
    content: [
      "纸箱最底下压着一本相册，封面已经泛黄。苏念一页页翻过去，看到母亲年轻时站在厂门口的样子。",
      "何淑芬淡淡地讲起当年的故事，语气平静，像在说别人的事。苏念却听得红了眼眶。",
      "那一晚，母女俩聊了很久。苏念第一次觉得，自己终于开始懂得“母亲”这两个字的重量。",
    ],
    publishedAt: "2024-09-20",
    castIds: ["c1", "c3"],
    clipIds: ["k8"],
  },
  {
    id: "s10",
    title: "学区房的风波",
    subtitle: "第二季 · 第4集",
    season: "第二季",
    episode: 4,
    tags: ["现实", "冲突", "抉择"],
    cover:
      "https://readdy.ai/api/search-image?query=A%20couple%20reviewing%20house%20documents%20at%20a%20kitchen%20table%20late%20at%20night%2C%20calculator%20and%20paperwork%2C%20warm%20lamp%20light%20and%20weary%20expressions%2C%20cinematic%20drama%20still%2C%20muted%20amber%20tones&width=800&height=450&seq=story-10&orientation=landscape",
    summary:
      "为了小满上小学，江辰提出置换学区房。面对经济压力与生活方式的取舍，夫妻二人再次站在了选择题前。",
    content: [
      "房产中介带来的报价单摊了一桌子。江辰算了一遍又一遍，眉头越皱越紧。",
      "苏念不愿意为了一个学区，把一家人逼到喘不过气。她说，孩子的童年只有一次。",
      "两个人争到半夜，最后在阳台上吹着风，一起想出了折中的办法。生活从来不是标准答案。",
    ],
    publishedAt: "2024-09-27",
    castIds: ["c1", "c2", "c4"],
    clipIds: ["k10"],
  },
  {
    id: "s11",
    title: "雨夜的和解",
    subtitle: "第二季 · 第5集",
    season: "第二季",
    episode: 5,
    tags: ["高潮", "和解", "温情"],
    cover:
      "https://readdy.ai/api/search-image?query=Two%20people%20holding%20umbrellas%20reconciling%20on%20a%20rainy%20evening%20street%2C%20wet%20asphalt%20reflecting%20warm%20streetlights%2C%20emotional%20embrace%2C%20cinematic%20drama%20still%2C%20warm%20rainy%20amber%20palette&width=800&height=450&seq=story-11&orientation=landscape",
    summary:
      "一场大雨里，苏念与沈予安把多年前没说清的话说了出来。告别之后，她终于可以坦然地向前走。",
    content: [
      "雨下得很大，苏念站在公交站台下，沈予安撑着伞走过来。",
      "两个人把从前的误会一件件摊开，说着说着都笑了。原来时间真的能冲淡很多东西。",
      "分别时，沈予安说祝她幸福。苏念说，谢谢你来过。转身的那一刻，她心里前所未有地轻松。",
    ],
    publishedAt: "2024-10-04",
    castIds: ["c1", "c5"],
    clipIds: ["k4", "k2"],
  },
  {
    id: "s12",
    title: "重新出发的自己",
    subtitle: "第二季 · 第6集",
    season: "第二季",
    episode: 6,
    tags: ["成长", "结局", "希望"],
    cover:
      "https://readdy.ai/api/search-image?query=A%20confident%20young%20woman%20walking%20forward%20on%20a%20sunny%20city%20sidewalk%20with%20a%20laptop%20bag%2C%20warm%20morning%20light%2C%20hopeful%20expression%2C%20cinematic%20drama%20still%2C%20terracotta%20and%20cream%20tones&width=800&height=450&seq=story-12&orientation=landscape",
    summary:
      "经历了两季的起落，苏念终于在家庭与事业之间找到了属于自己的节奏。她重新拿起画笔，也重新认识了自己。",
    content: [
      "苏念在社区活动室办了一场小小的画展，来的都是邻居和孩子。小满在画前骄傲地说，这是我妈妈画的。",
      "江辰站在人群后面，拍下这一幕。他忽然明白，妻子找回的不只是工作，而是她自己。",
      "片尾，苏念在日记本上写下：所谓母亲，不是牺牲自己，而是带着孩子一起长大。",
    ],
    publishedAt: "2024-10-11",
    castIds: ["c1", "c2", "c4", "c8"],
    clipIds: ["k2", "k9"],
  },
  {
    id: "s13",
    title: "写给五年后的信",
    subtitle: "特别篇 · 第1集",
    season: "特别篇",
    episode: 1,
    tags: ["特别篇", "回望", "温情"],
    cover:
      "https://readdy.ai/api/search-image?query=Handwritten%20letter%20and%20pen%20on%20a%20desk%20beside%20a%20warm%20cup%20of%20tea%2C%20soft%20morning%20light%20through%20sheer%20curtains%2C%20reflective%20mood%2C%20cinematic%20drama%20still%2C%20cream%20and%20clay%20palette&width=800&height=450&seq=story-13&orientation=landscape",
    summary:
      "特别篇以一封写给五年后的信串联全剧。苏念回望这一路，把想说的话留给了未来的自己和女儿。",
    content: [
      "苏念坐在书桌前，铺开信纸，写下“给小满，也给我自己”。",
      "信里写着那些忙碌、疲惫、争吵，也写着深夜里孩子熟睡时的安宁。",
      "信的结尾只有一句话：愿你长大后，也能勇敢地成为你自己。",
    ],
    publishedAt: "2024-10-18",
    castIds: ["c1", "c4", "c3"],
    clipIds: ["k8", "k3"],
  },
];